import React from "react"
import ShowListInternalApp from "./list/app"
import ShowListExternalApp from "./list_external/app"

export const ShowListApp = () => {
  if (site.currentEnvironment.type === "internal") {
    return <ShowListInternalApp />
  } else {
    return <ShowListExternalApp />
  }
}